<ng-container *ngIf="buttonBehavior; else regularLink">
    <a href="javascript:;" (click)="onPress($event)">{{text}}</a>
</ng-container>

<ng-template #regularLink>
    <a href="{{url}}" [target]="openInNewTab ? '_blank' : '_self'">{{text}}</a>
</ng-template>
